var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "powerbar-nav-second-level-panel" },
    _vm._l(_vm.panelData, function(column, panelIndex) {
      return _c(
        "ul",
        {
          key: column.caption,
          staticClass: "powerbar-nav-second-level-panel__column"
        },
        [
          _vm._l(column, function(group, groupIndex) {
            return [
              _vm._l(group.items, function(item, index) {
                return _c("SecondLevelMenuItem", {
                  key: item.caption + "-row",
                  attrs: {
                    itemData: item,
                    itemIndex: panelIndex + "." + groupIndex + "." + index
                  },
                  on: { navigate: _vm.navigate }
                })
              }),
              _vm._v(" "),
              groupIndex != Object.keys(column).length - 1
                ? _c(
                    "li",
                    {
                      key: group.caption + "break",
                      staticClass: "powerbar-nav-second-level-panel__break-row"
                    },
                    [_vm._m(0, true)]
                  )
                : _vm._e()
            ]
          })
        ],
        2
      )
    }),
    0
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "td",
      {
        staticClass: "powerbar-nav-second-level-panel__group-break",
        attrs: { colspan: "3" }
      },
      [_c("hr")]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }